import { fromJS } from 'immutable';
import { AnyAction } from 'redux';

import type { TypedMap } from 'utils/typed-map';

import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  SHOW_TAB,
  IMPERSONATE,
  IMPERSONATE_SUCCESS,
  IMPERSONATE_FAILED,
} from './constants';

type VolunteerPageState = TypedMap<{
  loading: boolean;
  tab: string;
  impersonating: boolean;
}>;

export const initialState = fromJS({
  loading: false,
  tab: 'upcomingDeeds',
  impersonating: false,
}) as VolunteerPageState;

function volunteerPageReducer(state = initialState, action: AnyAction): VolunteerPageState {
  switch (action.type) {
    case INIT:
      return state.set('loading', true);

    case INIT_SUCCESS:
      return state.merge({ loading: false });

    case SHOW_TAB:
      return state.set('tab', action.tab);

    case INIT_FAILED:
      return state.merge({ loading: false, error: action.error });

    case IMPERSONATE:
      return state.set('impersonating', true);

    case IMPERSONATE_SUCCESS:
    case IMPERSONATE_FAILED:
      return state.set('impersonating', false);

    default:
      return state;
  }
}

export default volunteerPageReducer;
